<template>
	<div style="padding-bottom: 50px;">
		<van-nav-bar class="nav-bar newnavbar" :title="$t('tabbar3')">
			<template #right>
				<van-image width="18" src="img/clm.png" style="margin-right: 10px;" @click="listType = 'clm'" />
				<van-image width="22" src="img/row.png" @click="listType = 'row'" />
			</template>
		</van-nav-bar>
		<div class="banner">
			<van-swipe :autoplay="3000" :show-indicators="false">
				<van-swipe-item v-for="(v, key) in banners" :key="key">
					<van-image :src="v" :height="200" width="100%" fit="cover">
						<template v-slot:loading>
							<van-loading type="spinner" size="20" />
						</template>
						<template v-slot:error><van-image src="img/error.png" /></template>
					</van-image>
				</van-swipe-item>
			</van-swipe>
		</div>
		<van-tabs title-inactive-color="#000" title-active-color="#000" animated swipeable>
			<van-tab :title="ChooseData[$i18n.locale]" :name="3" :title-style="{ fontWeight: 'bold' }"></van-tab>
		</van-tabs>
		<div>
			<div class="pblBox" v-show="listType === 'clm'">
				<div style="width: calc(50% - 5px);" v-for="(v, i) in datalist" :key="i">
					<releaseItem :rowData="v"></releaseItem>
				</div>
			</div>
			<div v-show="listType === 'row'" style="padding: 0 10px;">
				<horizontalItem v-for="(v, i) in datalist" :key="i" :rowData="v"></horizontalItem>
			</div>
		</div>
		<van-empty v-if="!datalist.length" image-size="50px" style="width: 100%; padding-top: 90px; color: #000;"
			image="img/emptyData.png" :description="$t('emptyData')" />
	</div>
</template>

<script>
import releaseItem from '@/common/releaseItem.vue'
import horizontalItem from '@/common/horizontalItem.vue'
export default {
	components: {
		releaseItem,
		horizontalItem
	},
	data() {
		return {
			listType: 'clm',
			banners: [],
			datalist: [],
		};
	},
	created() {
		this.getBanner();
		this.getxuanfeilist();
	},
	methods: {
		getBanner() {
			this.$httpNew({
				method: 'post',
				data: {},
				url: 'get_banners'
			}).then(res => {
				if (res.code == 0) {
					this.banners = res.images || [];
				} else {
					this.banners = [];
				}
			})
		},
		getxuanfeilist() {
			this.$httpNew({
				method: 'get',
				url: 'get_goods_list',
				data: {
					type: this.GoodsInfo[this.$i18n.locale],
				}
			}).then(res => {
				this.datalist = res.data || [];
				// 随机选取 1/3 个不重复的索引
				let numValue = Math.round(this.datalist.length / 3);
				let randomIndexes = [];
				while (randomIndexes.length < numValue) {
					let rand = Math.floor(Math.random() * this.datalist.length);
					if (!randomIndexes.includes(rand)) {
						randomIndexes.push(rand);
					}
				}

				// 设置这 1/3 个对象的数据
				randomIndexes.forEach(index => {
					this.datalist[index].offline = 1;
				});
			});
		},
		profile(v) {
			this.$router.push({
				path: '/profile?id=' + v.id
			});
		},
	},
};
</script>

<style lang="less" scoped>
@notice-bar-size: 30px;

.pblBox {
	display: flex;
	justify-content: space-between;
	padding: 10px;
	flex-wrap: wrap;
}

.page {
	position: absolute !important;
	top: 0;
	left: 0;
	right: 0;
	background-color: #f2f2f5;
}

.newnavbar {
	// background: linear-gradient(90deg, #7e5678, #e6c3a1);
	height: 100px;
	background: #000000;
}

.van-nav-bar {
	line-height: 50px;
}

::v-deep .van-nav-bar__title {
	max-width: 60%;
	margin: 0 auto;
	color: #ffffff;
	font-size: 35px;
}

::v-deep .van-nav-bar__content {
	height: 100px;
}

.van-sidebar {
	width: 180px;
}

.convention-hall {
	display: flex;
	flex-direction: column;
	bottom: 20px;
	background: #f2f2f5;
	padding-bottom: 50px;
}

::v-deep .van-tab {
	font-size: 30px;
	line-height: 100px;
	font-weight: bold;
}

::v-deep .van-tabs__line {
	background-color: #7e5678;
}

::v-deep .van-tabs--line .van-tabs__wrap {
	height: 100px;
}

::v-deep .van-tabs__wrap--scrollable .van-tab {
	padding: 0 23px;
}

.card {
	background-color: #8a637d;
	padding: 0.625rem;
	width: 95%;
	color: white;
	font-size: 0.8125rem;
	margin: 0.625rem auto;
	border-radius: 0.375rem;
}

::v-deep .van-row--flex {
	height: 80px;
	line-height: 80px;
}

.rig-box {
	width: 95%;
	margin: 0.625rem auto;
}

.rig-title {
	color: #0bdab0;
	font-size: 1.125rem;
}

.rig-content {
	font-size: 20px;
	// margin-top: 10px;
}

.address {
	width: 90%;
	margin: 0 auto;
	padding: 30px;
	height: calc(100vh - 510px);
	overflow: auto;
	background: #fff;
}

::v-deep .van-notice-bar__left-icon,
.van-notice-bar__right-icon {
	min-width: 40px;
}

.notice-swipe {
	// width: calc(100% - 50px);
	height: 85px;
	font-size: @notice-bar-size;
	border-radius: 50px;
}

::v-deep .van-grid-item__content--center {
	border-radius: 15px;
	padding: 0;
	height: auto;
	overflow: hidden;

}

::v-deep van-grid-item__content {
	position: relative;
}

.rig-name {
	// width: 100%;
	// height: 60px;
	// line-height: 60px;
	// margin-top: 10px;
	// background-color: #f7f7f7;
	// border-radius: 0 0 15px 15px;
	font-size: 15px;
	// padding-left: 10px;
	position: absolute;
	bottom: 20px;
	left: 10px;
	color: #fff;
	font-size: 26px;
}

.toptxt {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	background: linear-gradient(to right, rgba(239, 172, 54, 0.7), rgba(241, 211, 34, 0.8));
	color: #fff;
	padding: 2px 5px;
	text-align: center;
	font-size: 26px;
}

.titBox {
	display: flex;
	padding: 20px;
	justify-content: space-between;
	align-items: center;

	>div:nth-child(1) {
		color: #280064;
		font-weight: 600;
	}

	>div:nth-child(2) {
		background: #b78afb;
		color: #fff;
		padding: 15px;
		border-radius: 10px;
	}
}

.list-wrapper {
	padding: 0 0 200px 0;
}

.cityBox {

	padding: 20px;

	>div {
		display: flex;
		flex-wrap: wrap;
		align-items: center;

		>div {
			color: #523e90;
			font-size: 26px;
			border-radius: 30px;
			padding: 15px;
			background: #fff;
			margin: 0 20px 20px 0;
		}

	}
}

::v-deep .van-popup {
	background: #ffffffcc;

	.van-popup__close-icon {
		color: #62519a;
		font-size: 36px;
	}
}

.Main {
	border: 1px solid #ccc;

	.Item {
		margin-top: 5px;
		height: 30px;
		line-height: 30px;
		background: red;

	}
}

.bottom {
	background: green;
	height: 0px;
	margin-bottom: 0px;
}

::v-deep .van-tabs__line {
	bottom: 30px;
	width: 60px;
	height: 5px;
	border-radius: 8px;
	background-color: #000;
}

::v-deep .van-empty__description {
	color: #000;
}
</style>